// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Config from "../../../../../Config.bs.js";
import * as OrderRepo from "../../../../../library/data-source/order/repo/OrderRepo.bs.js";
import * as SurgeRepo from "./surge-dashboard/SurgeRepo.bs.js";
import * as DriverRepo from "../../../partner-dashboard/app/partner/repo/DriverRepo.bs.js";
import * as WalletRepo from "../../../partner-dashboard/app/wallet/repo/WalletRepo.bs.js";
import * as CustomerRepo from "../../../customer-ecosystem/app/repo/CustomerRepo.bs.js";
import * as WorkSpaceRepo from "./workSpace/WorkSpaceRepo.bs.js";
import * as BasicOrderRepo from "./basic-order/BasicOrderRepo.bs.js";
import * as DummyOrderRepo from "../../../../../library/data-source/order/repo/DummyOrderRepo.bs.js";
import * as DummySurgeRepo from "./surge-dashboard/DummySurgeRepo.bs.js";
import * as SuspensionRepo from "../../../partner-dashboard/app/suspension/repo/SuspensionRepo.bs.js";
import * as DummyDriverRepo from "../../../partner-dashboard/app/partner/repo/DummyDriverRepo.bs.js";
import * as DummyWalletRepo from "../../../partner-dashboard/app/wallet/repo/DummyWalletRepo.bs.js";
import * as TerminationRepo from "../../../partner-dashboard/app/termination/repo/TerminationRepo.bs.js";
import * as AdminDetailsRepo from "./admin-details/AdminDetailsRepo.bs.js";
import * as DummyCustomerRepo from "../../../customer-ecosystem/app/repo/DummyCustomerRepo.bs.js";
import * as DriverEarningsRepo from "../../../partner-dashboard/app/earnings/repo/DriverEarningsRepo.bs.js";
import * as DummyWorkSpaceRepo from "./workSpace/DummyWorkSpaceRepo.bs.js";
import * as PremiumPartnerRepo from "../../../partner-dashboard/app/premium-partner/repo/PremiumPartnerRepo.bs.js";
import * as ServiceabilityRepo from "../../../partner-dashboard/app/serviceability/repo/ServiceabilityRepo.bs.js";
import * as DummyBasicOrderRepo from "./basic-order/DummyBasicOrderRepo.bs.js";
import * as DummySuspensionRepo from "../../../partner-dashboard/app/suspension/repo/DummySuspensionRepo.bs.js";
import * as OrderDetailsMapRepo from "../../../order-dashboard/app/order-details-map/repo/OrderDetailsMapRepo.bs.js";
import * as DummyTerminationRepo from "../../../partner-dashboard/app/termination/repo/DummyTerminationRepo.bs.js";
import * as DummyAdminDetailsRepo from "./admin-details/DummyAdminDetailsRepo.bs.js";
import * as DummyDriverEarningsRepo from "../../../partner-dashboard/app/earnings/repo/DummyDriverEarningsRepo.bs.js";
import * as DummyPremiumPartnerRepo from "../../../partner-dashboard/app/premium-partner/repo/DummyPremiumPartnerRepo.bs.js";
import * as DummyServiceabilityRepo from "../../../partner-dashboard/app/serviceability/repo/DummyServiceabilityRepo.bs.js";
import * as DummyOrderDetailsMapRepo from "../../../order-dashboard/app/order-details-map/repo/DummyOrderDetailsMapRepo.bs.js";

function getDriverRepo(param) {
  if (Config.Env.env === "development") {
    return {
            fetchDriver: DummyDriverRepo.DriverRepo.fetchDriver,
            fetchPartnerDocuments: DummyDriverRepo.DriverRepo.fetchPartnerDocuments,
            fetchPartnerWaitlistInfo: DummyDriverRepo.DriverRepo.fetchPartnerWaitlistInfo,
            fetchPartnerOnboardingInfo: DummyDriverRepo.DriverRepo.fetchPartnerOnboardingInfo,
            fetchFilterDrivers: DummyDriverRepo.DriverRepo.fetchFilterDrivers
          };
  } else {
    return DriverRepo.DriverRepo;
  }
}

function getCustomerRepo(param) {
  if (Config.Env.env === "development") {
    return {
            fetchCustomer: DummyCustomerRepo.CustomerRepo.fetchCustomer,
            updateCustomer: DummyCustomerRepo.CustomerRepo.updateCustomer,
            fetchTransationHistory: DummyCustomerRepo.CustomerRepo.fetchTransationHistory,
            fetchCustomerOrder: DummyCustomerRepo.CustomerRepo.fetchCustomerOrder,
            addSecondaryNumber: DummyCustomerRepo.CustomerRepo.addSecondaryNumber,
            verifyOtp: DummyCustomerRepo.CustomerRepo.verifyOtp,
            resendOTP: DummyCustomerRepo.CustomerRepo.resendOTP,
            verifyEmail: DummyCustomerRepo.CustomerRepo.verifyEmail,
            sendPaymentLink: DummyCustomerRepo.CustomerRepo.sendPaymentLink,
            updateWalletBalance: DummyCustomerRepo.CustomerRepo.updateWalletBalance,
            fetchCashback: DummyCustomerRepo.CustomerRepo.fetchCashback,
            fetchPorterGoldDetails: DummyCustomerRepo.CustomerRepo.fetchPorterGoldDetails,
            fetchCustomerConsents: DummyCustomerRepo.CustomerRepo.fetchCustomerConsents,
            updateCustomerConsents: DummyCustomerRepo.CustomerRepo.updateCustomerConsents
          };
  } else {
    return {
            fetchCustomer: CustomerRepo.CustomerRepo.fetchCustomer,
            updateCustomer: CustomerRepo.CustomerRepo.updateCustomer,
            fetchTransationHistory: CustomerRepo.CustomerRepo.fetchTransationHistory,
            fetchCustomerOrder: CustomerRepo.CustomerRepo.fetchCustomerOrder,
            addSecondaryNumber: CustomerRepo.CustomerRepo.addSecondaryNumber,
            verifyOtp: CustomerRepo.CustomerRepo.verifyOtp,
            resendOTP: CustomerRepo.CustomerRepo.resendOTP,
            verifyEmail: CustomerRepo.CustomerRepo.verifyEmail,
            sendPaymentLink: CustomerRepo.CustomerRepo.sendPaymentLink,
            updateWalletBalance: CustomerRepo.CustomerRepo.updateWalletBalance,
            fetchCashback: CustomerRepo.CustomerRepo.fetchCashback,
            fetchPorterGoldDetails: CustomerRepo.CustomerRepo.fetchPorterGoldDetails,
            fetchCustomerConsents: CustomerRepo.CustomerRepo.fetchCustomerConsents,
            updateCustomerConsents: CustomerRepo.CustomerRepo.updateCustomerConsents
          };
  }
}

function getSuspensionRepo(param) {
  if (Config.Env.env === "development") {
    return {
            fetchSuspensionInfo: DummySuspensionRepo.SuspensionRepo.fetchSuspensionInfo,
            fetchSuspensionReasons: DummySuspensionRepo.SuspensionRepo.fetchSuspensionReasons,
            suspendPartner: DummySuspensionRepo.SuspensionRepo.suspendPartner,
            unsuspendPartner: DummySuspensionRepo.SuspensionRepo.unsuspendPartner
          };
  } else {
    return SuspensionRepo.SuspensionRepo;
  }
}

function getTerminationRepo(param) {
  if (Config.Env.env === "development") {
    return {
            fetchTerminationInfo: DummyTerminationRepo.TerminationRepo.fetchTerminationInfo,
            fetchTerminationReasons: DummyTerminationRepo.TerminationRepo.fetchTerminationReasons,
            terminateDriver: DummyTerminationRepo.TerminationRepo.terminateDriver,
            reactivateDriver: DummyTerminationRepo.TerminationRepo.reactivateDriver
          };
  } else {
    return TerminationRepo.TerminationRepo;
  }
}

function getWalletRepo(param) {
  if (Config.Env.env === "development") {
    return {
            fetchWallet: DummyWalletRepo.WalletRepo.fetchWallet,
            fetchAdminTransactionReasons: DummyWalletRepo.WalletRepo.fetchAdminTransactionReasons,
            createTransaction: DummyWalletRepo.WalletRepo.createTransaction
          };
  } else {
    return {
            fetchWallet: WalletRepo.WalletRepo.fetchWallet,
            fetchAdminTransactionReasons: WalletRepo.WalletRepo.fetchAdminTransactionReasons,
            createTransaction: WalletRepo.WalletRepo.createTransaction
          };
  }
}

function getDriverEarningsRepo(param) {
  if (Config.Env.env === "development") {
    return {
            fetchDriverEarningSummaries: DummyDriverEarningsRepo.DummyDriverEarningsRepo.fetchDriverEarningSummaries,
            fetchDriverDailyEarningDetails: DummyDriverEarningsRepo.DummyDriverEarningsRepo.fetchDriverDailyEarningDetails
          };
  } else {
    return DriverEarningsRepo.DriverEarningsRepo;
  }
}

function getSurgeRepo(param) {
  if (Config.Env.env === "development") {
    return {
            fetchCampaigns: DummySurgeRepo.DummySurgeRepo.fetchCampaigns,
            fetchGeoRegions: DummySurgeRepo.DummySurgeRepo.fetchGeoRegions,
            fetchVehicleTypes: DummySurgeRepo.DummySurgeRepo.fetchVehicleTypes,
            fetchZones: DummySurgeRepo.DummySurgeRepo.fetchZones,
            createCampaign: DummySurgeRepo.DummySurgeRepo.createCampaign,
            deleteCampiagn: DummySurgeRepo.DummySurgeRepo.deleteCampiagn
          };
  } else {
    return SurgeRepo.SurgeRepo;
  }
}

function getAdminDetailsRepo(param) {
  var match = Config.Env.env;
  if (match === "development") {
    return DummyAdminDetailsRepo.AdminDetailsRepo;
  } else {
    return AdminDetailsRepo.AdminDetailsRepo;
  }
}

function getBasicOrderRepo(param) {
  var match = Config.Env.env;
  if (match === "development") {
    return {
            fetchBasicOrder: DummyBasicOrderRepo.BasicOrderRepo.fetchBasicOrder
          };
  } else {
    return BasicOrderRepo.BasicOrderRepo;
  }
}

function getFilterOrderRepo(param) {
  var match = Config.Env.env;
  if (match === "development") {
    return DummyOrderRepo.OrderRepo;
  } else {
    return OrderRepo.OrderRepo;
  }
}

function getServiceabilityRepo(param) {
  var match = Config.Env.env;
  if (match === "development") {
    return DummyServiceabilityRepo.ServiceabilityRepo;
  } else {
    return ServiceabilityRepo.ServiceabilityRepo;
  }
}

function getOrderDetailsMapRepo(param) {
  var match = Config.Env.env;
  if (match === "development") {
    return {
            fetchOrderMapData: DummyOrderDetailsMapRepo.OrderDetailsMapRepo.fetchOrderMapData
          };
  } else {
    return OrderDetailsMapRepo.OrderDetailsMapRepo;
  }
}

function getPremiumPartnerReportRepo(param) {
  var match = Config.Env.env;
  if (match === "development") {
    return {
            fetchSubscriptionReport: DummyPremiumPartnerRepo.PremiumPartner.fetchSubscriptionReport
          };
  } else {
    return PremiumPartnerRepo.PremiumPartner;
  }
}

function getWorkSpaceRepo(param) {
  var match = Config.Env.env;
  if (match === "development") {
    return DummyWorkSpaceRepo.WorkSpaceRepo;
  } else {
    return WorkSpaceRepo.WorkSpaceRepo;
  }
}

export {
  getDriverRepo ,
  getCustomerRepo ,
  getSuspensionRepo ,
  getTerminationRepo ,
  getWalletRepo ,
  getDriverEarningsRepo ,
  getSurgeRepo ,
  getAdminDetailsRepo ,
  getBasicOrderRepo ,
  getFilterOrderRepo ,
  getServiceabilityRepo ,
  getOrderDetailsMapRepo ,
  getPremiumPartnerReportRepo ,
  getWorkSpaceRepo ,
  
}
/* Config Not a pure module */
